import { ComponentProps, FC, PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import {
    HoverCard,
    HoverCardContent,
    HoverCardTrigger,
} from '../ui/Hover-Card.tsx';

type HoverCardContentProps = ComponentProps<typeof HoverCardContent>;

interface ScalePreviewProps {
    openDelay?: number;
    closeDelay?: number;
    triggerClassName?: string;
    hoverCardClassName?: string;
    side?: HoverCardContentProps['side'];
}

export const ScalePreview: FC<PropsWithChildren<ScalePreviewProps>> = ({
    children,
    openDelay = 0,
    closeDelay = 100,
    triggerClassName,
    hoverCardClassName,
    side,
}) => {
    return (
        <HoverCard openDelay={openDelay} closeDelay={closeDelay}>
            <HoverCardTrigger tabIndex={0}>
                <div className={clsx('flex-shrink-0', triggerClassName)}>
                    {children}
                </div>
            </HoverCardTrigger>
            <HoverCardContent
                side={side}
                sideOffset={10}
                className={clsx(
                    'w-64 overflow-hidden rounded-2xl bg-transparent p-0 ring-0',
                    hoverCardClassName,
                )}
            >
                {children}
            </HoverCardContent>
        </HoverCard>
    );
};
